import { render, staticRenderFns } from "./ModalReceptionDetails.vue?vue&type=template&id=61c51ec6&lang=pug&"
import script from "./ModalReceptionDetails.vue?vue&type=script&lang=js&"
export * from "./ModalReceptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports